import gql from 'graphql-tag';

export const GET_LENDER_PERFORMANCE_CONVERSION_TABLE = gql`
  query LenderPerformanceConversionTable($input: LenderPerformanceReportInput!) {
    lenderPerformance {
      result: conversionTable(input: $input) {
        success
        error
        entity {
          lenderProfileId
          lenderName
          sent
          approved
          funded
          approvalPct
          fundPct
          fundedAmount
          lookToBook
        }
      }
    }
  }
`;
